import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { StyleDetailRoom } from './style'
import {
  cutString2,
  TABLE,
  ROOM_TEXT,
  ROUTE,
  getLocaleDateStringFull,
  checkPermission,
  PERMISSION_PAGE,
  CREATE_DEFAULT,
  CREATE_BOOKING,
  MODAL_STATUS,
  SPACE_STATUS,
  FALLBACK_SPACE_TYPE_THEME,
  SPACE_TYPE_LABEL,
} from '../../../helpers'
import { ButtonCreate, Loader, ModalStatus, Topbar, ScrollBox } from '../../../components'
import { ACCOUNT, ROOM, MODAL, HOLIDAY, } from '../../../reduxs'
import moment from 'moment'
import { COLOR, IMG } from '../../../themes'
import apiService from '../../../reduxs/apiService'
import ExternalIcon from '../../../components/ExternalIcon'
import { ModalShowImage } from '../../../components/Modal/ModalShowImage'

export class DetailRoom extends Component {

  constructor(props) {
    super(props)
    const { location, displayDate } = props
    let path = location.pathname.toString().split('/')
    const roomId = Number(path[3])
    const currentDate = moment(displayDate).format('YYYY-MM-DD')

    this.state = {
      roomId,
      startDatetime: `${currentDate} 00:00:00`,
      endDatetime: `${currentDate} 23:59:00`,
      limit: 100,
      page: 1,
      statusFav: '',
      showRightArrow: false,
      hasOverflowHorizontal: false,
      userManual:'',
      isOpenModalShowImage: false,
      isError: false,
    }
    this.service.getListBookingOfRoom()
    this.service.getDetailRoom()

    this.galleryRef = React.createRef(null)
  }

  service = {
    objGetParams: () => {
      const {
        roomId,
        startDatetime,
        endDatetime,
        limit,
        page,
      } = this.state

      return {
        roomId,
        startDatetime,
        endDatetime,
        limit,
        page,
        status: '[0,1,2]',
        sorts: JSON.stringify([
          {
            type: 'ASC',
            column: 'startDatetime'
          },
          {
            type: 'DESC',
            column: 'endDatetime'
          }
        ]),
      }
    },
    getListBookingOfRoom: () => {
      const { roomAction } = this.props
      roomAction.getListBookingOfRoom(this.service.objGetParams())
    },
    getDetailRoom: () => {
      const { roomId } = this.state
      const { roomAction } = this.props
      roomAction.getDetailRoomV2({ roomId })
    },

    getRoomManual: (fileData) => {
      if (fileData && fileData.signedUrl) {
        const baseUrl = process.env.REACT_APP_BASE_API_URL || ''
        const fullUrl = fileData.signedUrl.startsWith('/') 
          ? `${baseUrl}${fileData.signedUrl.replace(/^\//, '')}` 
          : fileData.signedUrl
          
        this.setState({ 
          userManual: fullUrl,
          isOpenModalShowImage: true,
          isError: false
        })
      } else {
        this.setState({ 
          isOpenModalShowImage: true,
          isError: true,
        })
      }
    },
    setFav: (status) => {
      const { roomId } = this.state
      const { roomAction, roomReducer, accountReducer } = this.props


      if (status) {
        roomAction.clearFavouriteData({
          roomId: Number(roomId),
          companyId: Number(roomReducer.detailRoom.company?.id),
          username: accountReducer.user.username,
        }, () => {
          this.setState({ statusFav: 0 })
        })
      } else {
        roomAction.saveFavouriteData({
          roomId: Number(roomId),
          companyId: Number(roomReducer.detailRoom.company?.id),
          username: accountReducer.user.username,
        }, () => {
          this.setState({ statusFav: 1 })
        })

      }
    }
  }

  componentDidMount () {
    const { displayDate, getListHoliday, accountReducer } = this.props
    const startDateString = [displayDate.getFullYear(), '01', '01'].join('-')
    const endDateString = [displayDate.getFullYear(), '12', '31'].join('-')

    getListHoliday({
      startDatetime: startDateString,
      endDatetime: endDateString,
      companyId: accountReducer.user.companyId,
      limit: 999
    })
  }

  timeStringToMinutes = (timeStr) => {
    const [hour = '0', minute = '0'] = String(timeStr).split(':')
    return (Number(hour) * 60) + Number(minute)
  }

  bookingTimeToMinutes = (datetime) => {
    const timePart = String(datetime).split('T')[1] || '00:00'
    return this.timeStringToMinutes(timePart)
  }

  ceilToStep = (minutes, step) => Math.ceil(minutes / step) * step

  formatMinutes = (minutes, separator = ':') => {
    const hour = Math.floor(minutes / 60)
    const minute = minutes % 60
    return [String(hour).padStart(2, '0'), String(minute).padStart(2, '0')].join(separator)
  }

  getAvailableSlots = () => {
    const { roomReducer, accountReducer, displayDate } = this.props
    const bookings = roomReducer.listBookingOfRoom || []
    const step = accountReducer.user.minuteStep || 15
    const openMin = this.timeStringToMinutes(accountReducer.user.startOperatingTime || '00:00:00')
    const closeMin = this.timeStringToMinutes(accountReducer.user.endOperatingTime || '23:59:59')

    const todayStr = moment().format('YYYY-MM-DD')
    const displayStr = moment(displayDate).format('YYYY-MM-DD')
    if (displayStr < todayStr) return []

    let floorMin = openMin
    if (displayStr === todayStr) {
      const now = new Date()
      const nowMin = this.ceilToStep((now.getHours() * 60) + now.getMinutes(), step)
      floorMin = Math.max(openMin, nowMin)
    }
    if (floorMin >= closeMin) return []

    const sorted = bookings
      .map((item) => ({
        startMin: this.bookingTimeToMinutes(item.startDatetime),
        endMin: this.bookingTimeToMinutes(item.endDatetime),
      }))
      .sort((a, b) => a.startMin - b.startMin)

    const slots = []
    let cursor = floorMin
    for (const booking of sorted) {
      const bookingEnd = Math.min(booking.endMin, closeMin)
      if (bookingEnd <= cursor) continue
      if (booking.startMin >= closeMin) break
      if (booking.startMin > cursor) slots.push({ startMin: cursor, endMin: Math.min(booking.startMin, closeMin) })
      cursor = Math.max(cursor, bookingEnd)
      if (cursor >= closeMin) break
    }
    if (cursor < closeMin) slots.push({ startMin: cursor, endMin: closeMin })

    return slots.filter((slot) => slot.endMin > slot.startMin)
  }

  onClickAvailableSlot = (slot) => {
    const step = this.props.accountReducer.user.minuteStep || 15
    let startMin = this.ceilToStep(slot.startMin, step)
    if (startMin >= slot.endMin) startMin = slot.startMin
    const endMin = Math.min(startMin + 60, slot.endMin)
    this.toCreateBooking(this.formatMinutes(startMin), this.formatMinutes(endMin))
  }

  renderBookingRow = (item, key) => {
    let startTime = item.startDatetime.split('T')
    startTime = startTime[1].split(':')
    startTime = startTime[0] + '.' + startTime[1]
    let endTime = item.endDatetime.split('T')
    endTime = endTime[1].split(':')
    endTime = endTime[0] + '.' + endTime[1]

    let start = startTime
    let end = endTime
    let textColor = COLOR.BLACK_6
    let statusColor = COLOR.BLACK_6
    let statusText = ''

    if (item.status === 0) {
      textColor = COLOR.GRAY_27
      statusColor = COLOR.GRAY_27
      statusText = 'End'
    } else if (item.status === 1) {
      textColor = COLOR.BLACK_6
      statusColor = '#DC2626'
      statusText = 'Active'
    } else if (item.status === 2) {
      textColor = COLOR.BLACK_6
      statusColor = COLOR.BLACK_6
      statusText = 'Upcoming'
    }

    return (
      <tr className='schedule_data' key={key}>
        <td style={{ color: textColor }}>{`${start} - ${end}`}</td>
        <td style={{ color: textColor }}>
          <span className="text-truncate" title={item.projectName}>
            {item.projectName}
          </span>
        </td>
        <td>
          <div style={{ color: statusColor, fontFamily: 'NunitoSansSemiBold', fontWeight: 600, fontSize: '14px' }}>
            {statusText}
          </div>
        </td>
      </tr>
    )
  }

  renderAvailableRow = (slot, key) => {
    const { accountReducer } = this.props
    const availableColor = SPACE_STATUS.COLOR[SPACE_STATUS.AVAILABLE].text
    const timeText = `${this.formatMinutes(slot.startMin, '.')} - ${this.formatMinutes(slot.endMin, '.')}`

    return (
      <tr className='schedule_data available-row' key={key} onClick={() => this.onClickAvailableSlot(slot)}>
        <td>{timeText}</td>
        <td>
          <span className='book-now-link'>{ROOM_TEXT.BOOK_NOW[accountReducer.language]}</span>
        </td>
        <td>
          <div style={{ color: availableColor, fontFamily: 'NunitoSansSemiBold', fontWeight: 600, fontSize: '14px' }}>
            {ROOM_TEXT.STATUS.AVAILABLE[accountReducer.language]}
          </div>
        </td>
      </tr>
    )
  }

  displaySchedule = () => {
    const { roomReducer } = this.props
    if (!roomReducer.listBookingOfRoom) return []

    const bookedRows = roomReducer.listBookingOfRoom.map((item) => ({
      sortMin: this.bookingTimeToMinutes(item.startDatetime),
      render: (key) => this.renderBookingRow(item, key),
    }))
    const availableRows = this.getAvailableSlots().map((slot) => ({
      sortMin: slot.startMin,
      render: (key) => this.renderAvailableRow(slot, key),
    }))

    return [...bookedRows, ...availableRows]
      .sort((a, b) => a.sortMin - b.sortMin)
      .map((row, index) => row.render(index))
  }

  displayGallery = () => {
    const {
      roomReducer,
      accountReducer
    } = this.props
    let imageList = []

    const noImage = (
      <img
        className='no_image'
        aria-hidden
        src={IMG['no-image.png']}
        alt={ROOM_TEXT.NO_GALLARY[accountReducer.language]}
      />
    )

    const { gallery } = roomReducer.detailRoom
    const baseUrl = process.env.REACT_APP_BASE_API_URL || ''

    if (gallery && gallery.length > 0) {
      imageList = gallery.map((item, index) => {
        const imageUrl = item.thumbnailSignedUrl || item.signedUrl
        if (!imageUrl) return noImage

        const fullUrl = imageUrl.startsWith('/') ? `${baseUrl}${imageUrl.replace(/^\//, '')}` : imageUrl
        return (
          <img
            key={index}
            src={fullUrl}
            alt={item.originalName || ''}
          />
        )
      })
    } else {
      imageList = noImage
    }

    return imageList
  }

  displayFacility = () => {
    const { roomReducer, accountReducer } = this.props
    const { facilities } = roomReducer.detailRoom

    if (facilities && facilities.length > 0) {
      return facilities.map((item, index) => (
        <div className='facility-item' key={index}>
          {item.itemName}
        </div>
      ))
    }

    return <p className='facility-text'>{ROOM_TEXT.NO_FACILITY[accountReducer.language]}</p>
  }

  displayRoomManual = () => {
    const { roomReducer, settingReducer, accountReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme
    const { isOpenModalShowImage, isError } = this.state
    const { file, controlRoomManualUrl } = roomReducer.detailRoom
    const files = file || []
    let roomManualComponent

    if (controlRoomManualUrl) {
      roomManualComponent = (
        <div>
          <a className='link-icon' href={controlRoomManualUrl} target='_blank'>
            {CREATE_BOOKING.USER_MANUAL[accountReducer.language]}
            <ExternalIcon color={colorTheme} width={16} height={16} style={{ transform: 'translateY(2px)' }} />
          </a>
        </div>
      )
    } else if (files && files.length > 0) {
      roomManualComponent = (
        <div 
          onClick={() => this.service.getRoomManual(files[0])}
          className='link-icon'
        >
          <ModalShowImage 
            img={isError ? IMG['no_image.png'] : this.state.userManual} 
            isError={isError} 
            isOpenModalShowImage={isOpenModalShowImage} 
            colorTheme={colorTheme} 
            label={CREATE_BOOKING.USER_MANUAL[accountReducer.language]}
          />
        </div>
      )
    } else {
        roomManualComponent = (<p className='room-manual-text'>{ROOM_TEXT.NO_ROOM_MANUAL[accountReducer.language]}</p>)
    }

    return roomManualComponent
  }

  toCreateBooking = (startTime, endTime) => {
    const { roomId } = this.state
    const {
      history,
      displayDate,
    } = this.props
    const date = moment(displayDate).format('YYYY-MM-DD')
    const timeQuery = (startTime && endTime) ? `&startTime=${startTime}&endTime=${endTime}` : ''
    history.push(`${ROUTE.BOOKING.LINK}/create?date=${date}${timeQuery}&roomId=${roomId}&from=meetingroom_detail`)
  }

  displayFav = () => {
    const { statusFav } = this.state
    const { roomReducer } = this.props
    return (
      <img
        className='favorite'
        alt=''
        src={IMG[statusFav === '' ? roomReducer.detailRoom.isFavourite ? 'favorite.svg' : 'unfavorite.svg' : statusFav ? 'favorite.svg' : 'unfavorite.svg']}
        onClick={() => this.service.setFav(statusFav === '' ? roomReducer.detailRoom.isFavourite : statusFav)}
      />
    )
  }

  displayDataName = () => {
    const { roomReducer, accountReducer, settingReducer } = this.props
    const { detailRoom } = roomReducer
    const roomName = detailRoom.name
    const companyName = detailRoom.company?.name
    const floorName = detailRoom.floor?.floorLevel ? `${ROOM_TEXT.FLOOR[accountReducer.language]} ${detailRoom.floor.floorLevel}` : null
    const buildingName = detailRoom.building?.name
    const subTitle = [companyName, buildingName, floorName].filter(Boolean).join(', ')
    
    const capacity = detailRoom.capacity || 0
    const memberLabel = capacity > 1 ? ROOM_TEXT.MEMBER[accountReducer.language] : ROOM_TEXT.PERSON[accountReducer.language]
    const member = `( ${capacity} ${memberLabel} )`
    const information = detailRoom.information

    const isBusy = detailRoom.isUsing === 1

    const statusKey = isBusy ? SPACE_STATUS.BUSY : SPACE_STATUS.AVAILABLE
    const statusLabel = SPACE_STATUS.LABEL[statusKey][accountReducer.language]
    const statusTextColor = SPACE_STATUS.COLOR[statusKey].text
    const statusBgColor = SPACE_STATUS.COLOR[statusKey].bg

    const spaceType = detailRoom.spaceType || 'room'
    const parsedThemeConfig = settingReducer.settingTheme?.themeConfig || {}
    const spaceTypeTheme = parsedThemeConfig?.spaceType?.[spaceType]
    
    const defaultSpaceType = FALLBACK_SPACE_TYPE_THEME[spaceType] || FALLBACK_SPACE_TYPE_THEME.other
    const spaceTypeBg = spaceTypeTheme?.background || defaultSpaceType.bg
    const spaceTypeColor = spaceTypeTheme?.foreground || defaultSpaceType.text
    const displaySpaceType = SPACE_TYPE_LABEL[spaceType]?.[accountReducer.language] || spaceType.charAt(0).toUpperCase() + spaceType.slice(1)

    const bookmarkColor = settingReducer.settingTheme?.colorTheme || '#CFB58F'
    const { statusFav } = this.state
    const isFavorite = statusFav === '' ? detailRoom.isFavourite : statusFav
    const bookmarkIcon = isFavorite ? 'ic_press-bookmark-on.svg' : 'ic_press-bookmark-off.svg'

    return (
      <div>
        <div className='head_title'>
          <div className='head_left'>
            <div className='room_name'>{cutString2(roomName, 20)}</div>
            {spaceType && (
              <div 
                className='type-badge' 
                style={{ backgroundColor: spaceTypeBg, color: spaceTypeColor }}
              >
                {displaySpaceType}
              </div>
            )}
          </div>
          <div className='head_right'>
            <div 
              className='status-badge' 
              style={{ backgroundColor: statusBgColor, color: statusTextColor }}
            >
              {statusLabel}
            </div>
            <div 
              className='favorite-icon' 
              onClick={() => this.service.setFav(isFavorite)}
            >
              <div 
                style={{
                  width: '24px',
                  height: '24px',
                  backgroundColor: bookmarkColor,
                  WebkitMask: `url(${IMG[bookmarkIcon]}) no-repeat center`,
                  WebkitMaskSize: 'contain',
                  mask: `url(${IMG[bookmarkIcon]}) no-repeat center`,
                  maskSize: 'contain',
                  cursor: 'pointer'
                }}
              />
            </div>
          </div>
        </div>

        <div className='sub_title'>{subTitle}  {member}</div>
        <div className='information'>{information}</div>
      </div>
    )
  }

  shouldComponentUpdate (nextProps) {
    const {
      displayDate,
      roomAction
    } = this.props
    if (nextProps.displayDate.toString() !== displayDate.toString()) {
      roomAction.clearAllDetailRoom()
      const currentDate = moment(nextProps.displayDate).format('YYYY-MM-DD')
      this.setState({
        startDatetime: `${currentDate} 00:00:00`, // current
        endDatetime: `${currentDate} 23:59:00`,
      }, () => {
        this.service.getListBookingOfRoom()
        this.service.getDetailRoom()
      })

    }
    return true
  }

  onClickTextBreadcrumbStart = () => {
    const { history, displayDate } = this.props
    history.push(`${ROUTE.MEETING_ROOM.LIST}?date=${moment(displayDate).format('YYYY-MM-DD')}`)
  }

  renderLeft = (props) => {
    const { canScrollLeft, hasOverflowHorizontal, step, scrollLeft } = props

    if (!hasOverflowHorizontal || !canScrollLeft) {
      return null
    }

    if (this.state.hasOverflowHorizontal !== hasOverflowHorizontal) {
      this.setState({ hasOverflowHorizontal: hasOverflowHorizontal })
    }

    return (
      <div className='gallery-btn gallery-btn-left' onClick={() => scrollLeft(step)}>
        <div className='button-circle'>
          <img
            className='ic-left'
            src={IMG['arrow-left.svg']}
            alt='icon arrow left'
          />
        </div>
      </div>
    )
  }

  renderRight = (props) => {
    const { canScrollRight, hasOverflowHorizontal, step, scrollRight } = props

    if (!hasOverflowHorizontal || !canScrollRight) {
      return null
    }

    if (this.state.hasOverflowHorizontal !== hasOverflowHorizontal) {
      this.setState({ hasOverflowHorizontal: hasOverflowHorizontal })
    }

    return (
      <div className='gallery-btn gallery-btn-right' onClick={() => scrollRight(step)}>
        <div className='button-circle'>
          <img
            className='ic_right'
            src={IMG['arrow-right.svg']}
            alt='icon arrow right'
          />
        </div>
      </div>
    )
  }

  render () {
    const {
      roomReducer,
      accountReducer,
      settingReducer,
      displayDate,
      modalStatus,
      closeModalStatus,
    } = this.props
    const { language } = accountReducer
    const { colorTheme } = this.props.settingReducer.settingTheme
    const { detailRoom } = roomReducer
    let displayContent
    let color

    if (colorTheme === COLOR.VIOLET || colorTheme === COLOR.BLUE_7 || colorTheme === COLOR.ORANGE || colorTheme === COLOR.GREEN_2) {
      color = COLOR.WHITE
    } else {
      color = COLOR.BLACK_3
    }

    const scheduleRows = this.displaySchedule()

    if (detailRoom) {
      displayContent = (
        <div className='scrollableContent'>
          {(modalStatus && !modalStatus.status) &&
            <ModalStatus
              language={language}
              code={modalStatus.code}
              action={modalStatus.status
                ? `${CREATE_DEFAULT.EDIT[language]}${MODAL_STATUS.COMPLELTE[language]}`
                : MODAL_STATUS.WARNING[language]}
              text={modalStatus.status
                ? MODAL_STATUS.SUCCESS[language]
                : modalStatus.description}
              status={modalStatus.status}
              onClick={closeModalStatus}
              colorTheme={colorTheme}
            />
          }
          <Topbar
            onClickBackToBeforePage={this.onClickTextBreadcrumbStart}
            textBreadcrumbStart={TABLE.MEETTING_ROOM[accountReducer.language]}
            textBreadcrumbEnd={TABLE.ROOM_DETAIL[accountReducer.language]}
            textCenter={getLocaleDateStringFull(displayDate, accountReducer.language)}
          />
          <div className='container'>

            {detailRoom && this.displayDataName()}

            { /* gallery */}
            <div className='gallery'>
              <span>{ROOM_TEXT.GALLARY[accountReducer.language]}</span>

              <ScrollBox.Horizontal
                className='gallery-list'
                ref={this.galleryRef}
                step={900}
                renderLeft={this.renderLeft}
                renderRight={this.renderRight}
              >
                {this.displayGallery()}
              </ScrollBox.Horizontal>
            </div>

            { /* schedule */}
            <div className='schedule-table'>
              <span className='schedule-header'>{TABLE.TIME[accountReducer.language]}</span>
              <div className='schedule'>
                <div className="schedule_wrapper">
                  <table className='table_schedule'>
                    <thead>
                      <tr className='head_schedule' style={{ background: colorTheme }}>
                        <th>{TABLE.TIME[accountReducer.language]}</th>
                        <th>{TABLE.MEETTING_NAME[accountReducer.language]}</th>
                        <th className='collapsable'>{TABLE.STATUS[accountReducer.language]}</th>
                      </tr>
                    </thead>
                    <tbody className='schedule_body_scroll'>
                      {scheduleRows}
                    </tbody>
                  </table>
                  {
                    roomReducer.listBookingOfRoom && scheduleRows.length === 0 &&
                    <div className='schedule_no_data'>
                      <div className='schedule_no_data_text'>{ROOM_TEXT.NO_DATA[accountReducer.language]}</div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div className='facility-table'>
              <span className='facility-header'>{TABLE.FACILITY[accountReducer.language]}</span>
                <div className='facility'>
                  {this.displayFacility()}
                </div>
              </div>
              <div className='room-manual-table'>
              <span className='room-manual-header'>{TABLE.ROOM_MANUAL[accountReducer.language]}</span>
                <div className='room-manual'>
                  {this.displayRoomManual()}
                </div>
              </div>
            {
              checkPermission(accountReducer.permission, ROUTE.MEETING_ROOM.ACTION.CREATE) &&
              <ButtonCreate
                onClick={() => this.toCreateBooking()}
                settingReducer={settingReducer}
              />
            }
          </div>
        </div>
      )
    }

    let displayDetail = ''
    if (!detailRoom) {
      displayDetail = <Loader colorTheme={colorTheme} />
    } else if (checkPermission(accountReducer.permission, ROUTE.MEETING_ROOM.CODE)) {
      displayDetail = displayContent
    } else {
      displayDetail = <div style={{ margin: 'auto' }}>{PERMISSION_PAGE.NOT_FOUND[accountReducer.language]}</div>
    }

    const countRoom = roomReducer.listBookingOfRoom && roomReducer.listBookingOfRoom.length

    return (
      <StyleDetailRoom
        colorTheme={colorTheme}
        countRoom={countRoom}
      >
        {displayDetail}
      </StyleDetailRoom>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    accountAction: bindActionCreators(ACCOUNT.action, dispatch),
    roomAction: bindActionCreators(ROOM.action, dispatch),
    openModalStatus: (div) => dispatch(MODAL.action.openModalStatus(div)),
    closeModalStatus: () => dispatch(MODAL.action.closeModalStatus()),
    getListHoliday: (param) => dispatch(HOLIDAY.action.getListHoliday(param)),
  }
}

const mapStateToProps = ({
  accountReducer,
  loaderReducer,
  roomReducer,
  settingReducer,
  holidayReducer,
  modalReducer
}) => {
  return {
    accountReducer,
    loaderReducer,
    roomReducer,
    settingReducer,
    holidayReducer,
    modalStatus: modalReducer.status,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailRoom)

